/* esm.sh - applesauce-core@5.2.0/helpers/json */
export * from "/*applesauce-core@5.2.0/esnext/helpers/json.mjs";
